module.exports = __webpack_public_path__ + "img/horizontal_4_4_8003.27e3b95e.png";